import React from 'react';
import './unSaveCmponent.css';

interface ConfirmationModalProps {
  isVisible: boolean;
  onClose: () => void;
  onSave: () => void;
  isLoading: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ 
  isVisible, 
  onClose, 
  onSave, 
  isLoading 
}) => {
  if (!isVisible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">Unsaved Changes</h2>
        <p className="modal-message">You have unsaved changes. Do you want to save before leaving?</p>
        <div className="button-group">
          <button
            onClick={onSave}
            className="btn-save"
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : 'Save'}
          </button>
          <button
            onClick={onClose}
            className="btn-leave"
          >
            Leave
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
